import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OFFLINE_META } from 'app/core/db/offline-context';
import { BandScopeService } from '../../../reducers/band-scope.service';

export const offlineScopeInterceptor: HttpInterceptorFn = (req, next) => {
    const meta = req.context.get(OFFLINE_META);
    if (!meta) return next(req);

    if ((meta as any).scopeArgs) return next(req);

    const bandId = inject(BandScopeService).current;

    const scopeArgs = bandId ? { bandId } : { scope: 'desk' };

    const patchedMeta = { ...meta, scopeArgs };
    const patchedCtx = req.context.set(OFFLINE_META, patchedMeta as any);
    return next(req.clone({ context: patchedCtx }));
};
